"use strict";

var _tab = require("./utils/tab");
var _tab2 = _interopRequireDefault(_tab);
var _sign = require("./utils/sign");
var _sign2 = _interopRequireDefault(_sign);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var indexEvt = new _tab2.default();
indexEvt.globalInit();
window.commonParams = _sign2.default;